export const deviceTypeEnum = {
    airbolt: 'AirBolt Portable Smart Lock',
    shield_gps: 'AirBolt GPS',
    shield_card: 'AirBolt Card',
};
